import(/* webpackMode: "eager" */ "/home/indofishoil.com/public_html/src/app/global-error.tsx");
